var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "home-container" },
      [
        _c(
          "div",
          { staticClass: "hx-breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { "separator-class": "el-icon-arrow-right" } },
              [
                _c("el-breadcrumb-item", [_vm._v("首页")]),
                _c("el-breadcrumb-item", [_vm._v("供应系统")]),
                _c("el-breadcrumb-item", [_vm._v("基地管理")]),
                _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { name: "availabilityReport" } } },
                  [_vm._v("供应力上报")]
                ),
                _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { name: "record" } } },
                  [_vm._v("历史记录")]
                ),
                _c("el-breadcrumb-item", [_vm._v("历史记录详情")]),
              ],
              1
            ),
          ],
          1
        ),
        _c("hx-table-result-col", [
          _c("div", { staticClass: "wrap-table-info-display" }, [
            _c(
              "div",
              {
                staticClass: "mgl20",
                staticStyle: { "line-height": "30px", "font-weight": "500" },
              },
              [
                _c("span", [_vm._v("领货日期：")]),
                _vm.deliveryTakenDate
                  ? _c("span", { staticClass: "alert-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatDate")(_vm.deliveryTakenDate, true)
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _c("span", { staticClass: "table-info-display" }, [
              _c("span", [_vm._v("总条数：")]),
              _c("span", { staticClass: "alert-text ft16" }, [
                _vm._v(_vm._s(_vm.pager.total)),
              ]),
            ]),
          ]),
        ]),
        _c(
          "hx-table-result",
          {
            attrs: {
              "show-pager-on-one-page": false,
              "page-info": _vm.pager,
              loading: _vm.tableLoading,
            },
            on: {
              "page-current-change": _vm.handleCurrentChange,
              "page-size-change": _vm.handleSizeChange,
            },
          },
          [
            _c("div", { attrs: { slot: "action" }, slot: "action" }),
            _c(
              "el-table",
              {
                attrs: {
                  slot: "content",
                  data: _vm.tableData,
                  "max-height": "800",
                  border: "",
                },
                slot: "content",
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "goodsId",
                    align: "center",
                    fixed: "",
                    label: "序号",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "title",
                    align: "center",
                    fixed: "",
                    label: "产品名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "spec",
                    align: "center",
                    fixed: "",
                    label: "规格",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "stockTotal",
                    align: "center",
                    label: "基地供应能力",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "little", align: "center", label: "富余量" },
                }),
                _vm._l(_vm.columnList, function (item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: { align: "center", label: item.title },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.list[index])),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }